import { createFileRoute } from "@tanstack/react-router"
import { ProductDetailsPage } from "@/components/dashboard/seller/pages/products/ProductDetailsPage"

export const Route = createFileRoute("/products/$productId")({
  component: ProductDetailRoute,
})

function ProductDetailRoute() {
  const { productId } = Route.useParams()
  return <ProductDetailsPage productId={productId} />
}
